import type { StrategyBlock } from '@segmently/schema-models/strategy';
import type { LibraryAdaptationState } from '@modules/shared-types';

/** Safe additive read for blocks created before the library lifecycle existed. */
export function readLibraryAdaptationState(block: StrategyBlock): LibraryAdaptationState | undefined {
  const value = (block as { aiMeta?: { libraryAdaptation?: unknown } }).aiMeta?.libraryAdaptation;
  if (!value || typeof value !== 'object' || (value as LibraryAdaptationState).schemaVersion !== 1) {
    return undefined;
  }
  return value as LibraryAdaptationState;
}
